import { memo } from "react";

import { Text } from "@components/Text";
import { ProductHeroRatingPlaceholder } from "@react/sections/ProductHero/ProductHeroRating/ProductHeroRatingPlaceholder.view";
import { ReviewStars } from "@sections/ProductReviews/ReviewStars";
import { tw } from "classnames";

const styles = {
  container: tw("mb-4", "mg:mb-3", "flex", "flex-row", "items-center", "h-7"),
  text: tw("ml-2", "mb-0.5", "text-primary", "cursor-pointer"),
  stars: tw("text-special"),
};

const ProductHeroRatingViewBase = ({
  clickHandler,
  isLoading,
  rating,
  text,
}: {
  clickHandler: () => void;
  isLoading: boolean;
  rating: number | undefined;
  text: string;
}) => {
  if (isLoading || rating === undefined) {
    return <ProductHeroRatingPlaceholder />;
  }

  return (
    <div className={styles.container}>
      <ReviewStars className={styles.stars} rating={rating} size="sm" />
      <div onClick={clickHandler}>
        <Text as="caption" className={styles.text} size="xs">
          {text}
        </Text>
      </div>
    </div>
  );
};

export const ProductHeroRatingView = memo(ProductHeroRatingViewBase);
